<mat-toolbar class="secondary" color="primary">
  <div class="left">
    <ng-content select="[toolbar-left]" />
  </div>
  <div class="center">
    <ng-content select="[toolbar-center]" />
  </div>
  <div class="substate">
    <ng-content select="[toolbar-substate]" />
  </div>
  <div class="right">
    <ng-content select="[toolbar-right]" />
  </div>
  @if (loading$ | async) {
    <mat-progress-bar mode="indeterminate" class="loading-bar" />
  }
</mat-toolbar>
